import React from 'react';
import Typography, { Props as TypographyProps } from '@smart-tv/components/typography/typography';

export const PlayerInfoSubtitle: React.FC<TypographyProps> = (props: TypographyProps) => {
  const { children, ...rest } = props;

  return (
    <Typography variant="h2" component="h3" {...rest}>
      {children}
    </Typography>
  );
};

export default React.memo(PlayerInfoSubtitle);
